import { Box, Fab, InputBase } from "@mui/material"
import { SearchIcons } from "../../../../../../core/global/Icons"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import { Add } from "@mui/icons-material";
import { useContext } from "react"
import { ToolContext } from "../../../../../../core/context/ToolContext";

export const Top = ({ isLoading, conSearch, setConSearch }) => {
    const { install_state } = useContext(ToolContext)
    const nav = useHistory()
    const handleConcern = () => {
        nav.push('/speakout/concern/create')
    }
    
    const ALPHA_NUMERIC_DASH_REGEX = /[\w\s.,!?-]+$/ ;
    const handleSearch = (e) => {
        if (!isLoading.data) {
            isLoading.set(true)
        }
        setConSearch(e.target.value)
    }

    return (
        <Box>
            <Box p={"10px 20px 10px 20px"}>
                <InputBase fullWidth
                    onKeyDown={(event) => {
                        if (!ALPHA_NUMERIC_DASH_REGEX.test(event.key)) {
                        event.preventDefault();
                        }
                    }}
                    onPaste={(e)=>{
                        e.preventDefault()
                        return false;
                    }} 
                    onCopy={(e)=>{
                        e.preventDefault()
                        return false;
                    }}
                    value={conSearch}
                    onChange={(e) => handleSearch(e)}
                    placeholder="Search"
                    endAdornment={ <Box pr={1} pt={.5}><SearchIcons /></Box> }
                    sx={{backgroundColor: "#FFFFFFF", border: "2px solid #D9EBE8", borderRadius: "10px", padding: '5px 5px 5px 20px',   height:'49px'}}
                />
            </Box>
                <Box> 
                    <Box position="fixed" display="flex" flexDirection="column" alignItems="flex-end" right={25} zIndex={1101}  sx={{transition: 'bottom 0.3s ease 0s'}} bottom={(install_state.prompt.data !== null ? 139 :75) } >
                        <Fab  sx={{ bgcolor: '#107038ff', height: '48px', width: '48px', boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.04),0px 8px 16px rgba(0, 0, 0, 0.08)' ,}} onClick={handleConcern}>
                            <Add sx={{color: '#FFFFFF'}}/>
                        </Fab>
                    </Box>  
                </Box>
        </Box>
    )
}